import { render } from "./Itemedit4digitalbillbord.vue?vue&type=template&id=ef4f1310&scoped=true&ts=true"
import script from "./Itemedit4digitalbillbord.vue?vue&type=script&lang=ts"
export * from "./Itemedit4digitalbillbord.vue?vue&type=script&lang=ts"

import "./Itemedit4digitalbillbord.vue?vue&type=style&index=0&id=ef4f1310&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4f1310"]])

export default __exports__